import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

const KEY = "mordomo_cookie_consent_v1";

export default function CookieBanner() {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      // Private-browsing / Safari ITP can throw on localStorage access.
      // Banner stays hidden; this is intentional, not a bug.
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted-" + Date.now()); } catch {
      // Persistence may fail in private browsing; treat as transient.
    }
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-40 bg-[var(--bg)] border border-[var(--ink)] shadow-xl p-5"
      data-testid="cookie-banner"
    >
      <p className="label-cap text-[var(--oxblood)]">— {lang === "pt" ? "Cortesia digital" : "Digital courtesy"}</p>
      <p className="mt-2 text-[14px] leading-relaxed text-[var(--ink)]">
        {lang === "pt"
          ? "Usamos um único cookie técnico para manter a sua sessão. Nada de rastreamento, nada de publicidade. Pode rever a "
          : "We use a single technical cookie to keep your session. No tracking, no advertising. Review our "}
        <Link to="/privacy" className="text-[var(--oxblood)] underline" data-testid="cookie-banner-privacy-link">
          {lang === "pt" ? "política de privacidade" : "privacy policy"}
        </Link>
        {lang === "pt" ? " quando quiser." : " anytime."}
      </p>
      <div className="mt-4 flex gap-2 justify-end">
        <button onClick={accept} className="btn-primary text-sm" data-testid="cookie-banner-accept">
          {lang === "pt" ? "Compreendido" : "Understood"}
        </button>
      </div>
    </div>
  );
}
